var _excluded = ["property"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { agencyToProps, agentToProps, agentType } from './utils/graphql-mappings';
import { AgentSidebox } from '.';
import NextEvent from './next-event';
import { AgentSideboxFragmentDoc } from './agent-sidebox-graphql.generated';
import { jsx as ___EmotionJSX } from "@emotion/core";
var agentsFromAgencies = function agentsFromAgencies() {
  var agencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return agencies.map(agency => _objectSpread(_objectSpread({}, agentToProps({
    name: agency.name
  })), {}, {
    agency: agencyToProps(agency)
  }));
};
var buildAgents = _ref => {
  var agents = _ref.agents,
    agencies = _ref.agencies;
  return agents !== null && agents !== void 0 && agents.length ? agents.map(agent => _objectSpread(_objectSpread({}, agentToProps(agent)), {}, {
    agency: _objectSpread(_objectSpread({}, agencyToProps(agent.agency)), {}, {
      type: agentType(agent)
    })
  })) : agentsFromAgencies(agencies);
};
var graphQLToProps = _ref2 => {
  var _listing$nextInspecti, _listing$nextInspecti2, _listing$nextInspecti3;
  var listing = _ref2.listing,
    agents = _ref2.agents,
    agencies = _ref2.agencies;
  return {
    inspection: listing.nextInspection[0] ? {
      startDate: (_listing$nextInspecti = listing.nextInspection[0]) === null || _listing$nextInspecti === void 0 ? void 0 : _listing$nextInspecti.startTime,
      endDate: (_listing$nextInspecti2 = listing.nextInspection[0]) === null || _listing$nextInspecti2 === void 0 ? void 0 : _listing$nextInspecti2.endTime,
      eventId: (_listing$nextInspecti3 = listing.nextInspection[0]) === null || _listing$nextInspecti3 === void 0 ? void 0 : _listing$nextInspecti3.id
    } : undefined,
    agents: buildAgents({
      agents,
      agencies
    })
  };
};
var AgentSideboxGraphQL = _ref3 => {
  var property = _ref3.property,
    props = _objectWithoutProperties(_ref3, _excluded);
  return ___EmotionJSX(AgentSidebox, _extends({}, props, graphQLToProps(property)));
};
var agencyPropTypes = {
  agencyId: PropTypes.string,
  name: PropTypes.string,
  profileUrl: PropTypes.string,
  logoBackgroundColour: PropTypes.string,
  flags: PropTypes.arrayOf(PropTypes.string),
  images: PropTypes.shape({
    logo: PropTypes.string
  })
};
AgentSideboxGraphQL.propTypes = {
  property: PropTypes.shape({
    listing: PropTypes.shape({
      nextInspection: PropTypes.arrayOf(PropTypes.shape({
        startTime: PropTypes.string
      }))
    }),
    agencies: PropTypes.arrayOf(PropTypes.shape(agencyPropTypes)),
    agents: PropTypes.arrayOf(PropTypes.shape({
      agentId: PropTypes.string,
      name: PropTypes.string,
      profilePhoto: PropTypes.string,
      agency: PropTypes.shape(agencyPropTypes)
    }))
  }).isRequired,
  nextInspection: PropTypes.shape(NextEvent.propTypes)
};
AgentSideboxGraphQL.defaultProps = {
  nextInspection: undefined
};
AgentSideboxGraphQL.fragment = AgentSideboxFragmentDoc;
export default AgentSideboxGraphQL;